export const AppConfig = {
  title: 'DrDoGood',
  description: 'Talk to a doctor, therapist or medical expert anywhere you are by phone or video.',
  locale: 'en',
  siteName: 'DrDoGood',
}
